<app-notification-bar></app-notification-bar>

<nav
  class="navbar navbar-dark xsact-nav"
  #userDropdownMenu
  [ngClass]="{'floating': floating}">
  <a class="navbar-brand" href="#">
    <img src="/assets/images/transact_logo.png" />
  </a>
  @if (!isLoggedIn) {
    <div class="navbar-nav mr-auto"></div>
    <ul class="navbar-nav mr-5 page-links">
      @switch (currentRoute) {
        @case ('/') {
          <li>
            <a class="nav-link" routerLink="/landing/publisher" i18n>Publishers</a>
          </li>
          <li>
            <a class="nav-link" routerLink="/landing/consumer" i18n>Consumers</a>
          </li>
        }
        @case ('/signup') {
          <li>
            <a class="nav-link" routerLink="/signup" [queryParams]="{ which: 'publisher' }" i18n>Publishers</a>
          </li>
          <li>
            <a class="nav-link" routerLink="/signup" [queryParams]="{ which: 'reader' }" i18n>Consumers</a>
          </li>
        }
        @default {
          <li>
            <a class="nav-link" routerLink="/" i18n>Home</a>
          </li>
        }
      }
    </ul>
    <ul class="navbar-nav mr-5 page-links">
      <li>
        @switch (currentRoute) {
          @case ('/landing/publisher') {
            <a class="nav-link" routerLink="/signup"
              [queryParams]="{ returnUrl: returnUrl || '' , which: 'publisher' }">
                <span i18n>Signup</span><span class="separator"></span>
            </a>
          }
          @case ('/landing/consumer') {
            <a class="nav-link" routerLink="/signup"
              [queryParams]="{ returnUrl: returnUrl || '' , which: 'reader' }">
                <span i18n>Signup</span><span class="separator"></span>
            </a>
          }
          @default {
            <a class="nav-link" routerLink="/signup" [ngClass]="{ 'current-link' : ('/signup' === currentRoute)}"
              [queryParams]="{ returnUrl: returnUrl || '' , which: '' }">
                <span i18n>Signup</span><span class="separator"></span>
            </a>
          }
        }
      </li>
      <li>
        <a class="nav-link" routerLink="/login"
           [queryParams]="returnUrl ? { returnUrl: returnUrl } : ''"
           [ngClass]="{ 'current-link' : ('/login' === currentRoute)}" i18n>Login</a>
      </li>
    </ul>
  }
  <div class="user-lang-navigation">
    @if (isLoggedIn) {
      <button
        (click)="toggleCollapsedNavbar()"
        class="user-menu-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation">
        @if (user.first_name || user.last_name) {
          <span id="userMenu" class="username-label">
            {{ user.first_name + ' ' + user.last_name }}
          </span>
        } @else {
          <span id="userMenu">{{ user.email1 }}</span>
        }
        <img class="profile-image"
          [src]="user.profile_image +'?d=' + updatedTimestamp"
          appFallbackImage="/assets/images/plainAvatar.png" />

        <ul class="navbar-nav user-menu">
          <li class="nav-item dropdown">
            <div
              class="dropdown-menu"
              aria-labelledby="navbarDropdown"
              [ngClass]="{ 'active': headerCollapsedMenuOpen }">
              @if (groupPublishers && groupPublishers.length > 1) {
                <div class="publishers-selector">
                  <label>Select Publisher Profile</label>
                  <ul>
                    @for (publisher of groupPublishers; track publisher.id) {
                      <li
                        [ngClass]="{'selected': publisher.selected}"
                        [routerLink]="['/publisher', publisher.id, 'summary']">
                        <div class="tt__image-wrapper image-40-40 circle">
                          <img [src]="publisher.profile_image"
                            appFallbackImage="/assets/images/plainAvatar.png" />
                        </div>
                        <div class="name-status">
                          <span class="title">{{ publisher.org }}</span>
                          @if (publisher.own) {
                            <span class="status tt__text--blue">(owner)</span>
                          }
                        </div>
                      </li>
                    }
                  </ul>
                </div>
              }
              <!-- note: use href so bizops users can switch from other app-->
              @if (user.buyer && !user.seller) {
                <a href="/user/dashboard" class="dropdown-item" i18n>Dashboard</a>
              }
              @if (user.seller && (groupPublishers && groupPublishers.length === 1)) {
                <a routerLink="/publisher/summary"
                  class="dropdown-item" i18n>Publisher Summary</a>
              }
              @if (user.seller) {
                <a routerLink="/user/dashboard" class="dropdown-item" i18n>User Dashboard</a>
              }
              @if (user.staff) {
                <a href="/bizops/" class="dropdown-item" i18n>Bizops Dashboard</a>
              }
              <div class="dropdown-divider"></div>
              <a (click)="logout()" class="dropdown-item" i18n>Logout</a>
            </div>
          </li>
        </ul>
      </button>
    }
    <ul class="navbar-nav language-selector">
      <li dropdown class="language-selector__dropdown">
        <a class="nav-link" dropdownToggle><i class="fa fa-globe" aria-hidden="true"></i>{{ selectedLang ? selectedLang.name : '' }}</a>
        <ul *dropdownMenu class="dropdown-menu" aria-labelledby="languageMenu">
          @for (lang of supportedLangs; track lang.key) {
            <li>
              <a (click)="selectLanguage(lang.key)">{{ lang.name }}</a>
            </li>
          }
        </ul>
      </li>
    </ul>
  </div>
</nav>
